import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_formula-factory/artifacts/pa7xi9nc_WhatsApp%20Image%202026-02-25%20at%2005.34.59.jpeg";

export default function Footer() {
  return (
    <footer className="bg-udl-surface border-t border-udl-gray-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-2">
            <img src={LOGO_URL} alt="Unique Drinks Lab" className="h-14 mb-6" />
            <p className="text-udl-gray-400 text-sm leading-relaxed max-w-md">
              Unique Drinks Lab es una fábrica de bebidas con laboratorio propio que combina 
              innovación científica e infraestructura industrial para desarrollar bebidas 
              personalizadas listas para producción real.
            </p>
            <p className="text-udl-primary font-heading font-bold mt-4 text-sm tracking-wider">
              From Formula to Factory.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-udl-white font-heading font-bold mb-4 md:mb-6 text-sm uppercase tracking-wider">
              Navegación
            </h4>
            <ul className="space-y-2 md:space-y-3">
              {[
                { name: "Inicio", path: "/" },
                { name: "Configurador", path: "/configurador" },
                { name: "Fábrica", path: "/fabrica" },
                { name: "Servicios", path: "/servicios" },
                { name: "Nosotros", path: "/nosotros" },
                { name: "Contacto", path: "/contacto" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-udl-gray-400 hover:text-udl-primary text-sm transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-udl-white font-heading font-bold mb-4 md:mb-6 text-sm uppercase tracking-wider">
              Contacto
            </h4>
            <ul className="space-y-2 md:space-y-3 text-sm text-udl-gray-400">
              <li>
                info<span className="text-udl-primary">[arroba]</span>uniquedrinkslab.com
              </li>
              <li>+34 601 64 55 33</li>
              <li className="pt-2">
                <span className="text-udl-gray-700">Oficinas</span>
                <br />
                Avda. Santa Catalina 82
                <br />
                03725 Teulada (Alicante)
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-udl-gray-800 mt-8 md:mt-12 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-udl-gray-700 text-xs text-center md:text-left">
            © {new Date().getFullYear()} Unique Drinks Lab. Todos los derechos reservados.
          </p>
          <div className="flex gap-4 md:gap-6">
            <a href="#" className="text-udl-gray-700 hover:text-udl-gray-400 text-xs transition-colors">
              Política de privacidad
            </a>
            <a href="#" className="text-udl-gray-700 hover:text-udl-gray-400 text-xs transition-colors">
              Términos y condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
